module.exports = __webpack_public_path__ + "img/icon_red_cl.1e6d1c66.png";